import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import { getPolicy } from '../Common/apis';
import Loader from '../Components/Loader/Loader';

function PrivacyPolicy() {
  const fadeLeft = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7 } }
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(false);


  const fetchPolicy = async () => {
    setLoading(true);
    try {
      const response = await getPolicy();
      setPolicy(response.data);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPolicy();
  }, []);

  return (
    <section className="bg-[#F5F8FF] pt-[100px] md:py-[100px] py-[40px] px-4 md:px-[80px] overflow-hidden">
      {loading && <Loader />}
      <motion.div initial="hidden" animate="visible" variants={staggerContainer}>
        {/* <motion.h1
          className="font-[600] font-poppins md:text-[55px] text-[40px] md:leading-[65px] leading-[46px] tracking-[-2.2px] text-[#FF6000] text-center"
          variants={fadeLeft}
        >
          Privacy Policy
        </motion.h1> */}

        <div className="mt-10 space-y-6">
          {policy ? (
            <div
              variants={fadeLeft}
              dangerouslySetInnerHTML={{ __html: policy?.PrivacyPolicy }} />
          ) : (
            <div className="text-center text-gray-500 py-10">No Privacy Policy.</div>
          )}
        </div>
      </motion.div>
    </section>
  );
}

export default PrivacyPolicy;
